import React, { useCallback, useEffect, useRef, useState } from "react";
import { API, graphqlOperation, Storage } from "aws-amplify";
import GraphQLManager from "../../../../../util/appsync/GraphQLManager";
import StandardColors from "../../../../../util/StandardColors";
import { MedicalEmergencyHelper } from "../../../../../util/medical-emergency/MedicalEmergencyHelper";
import { NotificationHelper } from "../../../../../util/notification/NotificationHelper";
import { useUser } from "../../../context/User/UserContext";
import { Box, FileInput, Text } from "grommet";
import { ChatFeed, Message } from "react-chat-ui";
import "./ChatView.css";
import rightArrow from '../../../../../assets/rightArrow.svg';
import image from '../../../../../assets/image.svg';
import { observer } from "mobx-react";
import { useStore } from "../../../../../Hooks/useStore";
import { ChatType } from "./ChatCard";
import { Mixpanel } from "../../../../../util/Helper";
import { VideoCallNotificationHelper } from "../../../../../util/notification/VideoCallNotificationHelper";
//import MedicalEmergencyService from "../../../../../services/medical-emergency/medical-emergency.service";
//import { useParams } from "react-router-dom";
//import usersService from "../../../body/screens/IAM/Users/users.service";
//import { APIs } from "../../../../../util/api/APIs";

let graph = new GraphQLManager();

const ChatView = observer(({ roomId, chatType, medicalStatus }) => {
  //const { medicalEmergencyId } = useParams();
  const { rootStore } = useStore();
  const [messages, setMessages] = useState([]);
  const [windowWidth, setWindowWidth] = useState(0);
  const [textMessageInputValue, setTextMessageInputValue] = useState("");
  const [file, setFile] = useState(null);
  const [uploadErr, setUploadErr] = useState(null); // State to hold the selected file
  const fileInputRef = useRef(null);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  
  const { setUser, user } = useUser();

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getUser = async () => {
    try {
      rootStore.loadingStore.setShowLoader(true);
      let uInfo = localStorage.getItem("userinfo");
      if (uInfo) {
        const userinformation = JSON.parse(uInfo);
        setUser(userinformation);
      }
      rootStore.loadingStore.setShowLoader(false);
    } catch (e) {
      rootStore.loadingStore.setShowLoader(false);
    }
  };

  useEffect(() => {
    if (!user) {
      getUser();
    }
  }, [user]);

  const onNewMessage = useCallback(async (message) => {
    rootStore.loadingStore.setShowLoader(true);
    if (!user) await getUser();
    const subscribedMessage = message?.value?.data?.onCreateChatMessageRoomFilter;

    if (subscribedMessage.content && subscribedMessage) {
      let storeKey = process.env.REACT_APP_ENV === "PROD" ? "us-east-2" : "us-west-1";
      setMessages((previousMessages) => [
        ...previousMessages,
        subscribedMessage.content.indexOf(`skali-report.s3.${storeKey}.amazonaws.com/public/chatPhotos`) !== -1 
        ?
        new Message({
          id: subscribedMessage.author === user.username ? 0 : subscribedMessage.author,
          message: <img src={subscribedMessage.content} onClick={() => showImage(subscribedMessage.content)} style={{objectFit:'contain',cursor: 'pointer'}} height={100} width={100} />,
          senderName: subscribedMessage.author,
        })
        :
        new Message({
          id: subscribedMessage.author === user.username ? 0 : subscribedMessage.author,
          message: subscribedMessage.content,
          senderName: subscribedMessage.author,
        })
      ]);
    }
    rootStore.loadingStore.setShowLoader(false);
  }, [user]);

  useEffect(() => {
    setMessages([]);
    setIsLoadingMessages(true); // Use local loading state instead of rootStore
    rootStore.loadingStore.setShowLoader(true);

    setTimeout(() => {
      rootStore.loadingStore.setShowLoader(false);
    }, 1500);

    const subscribe = graph.subscribeForNewMessages(roomId, onNewMessage);

    const getMessages = async () => {
      let username_;
      let uInfo = localStorage.getItem("userinfo");
      if (uInfo) {
        username_ = JSON.parse(uInfo)?.username;
      }
      let messages_ = await graph.getMessagesForRoom(roomId);

      if (messages_ && messages_.length) {
        // Fixed the sorting line:
        messages_.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt));

        setMessages((prev) => {
          return [
            ...messages_.map((item) => {
              const content = item.content;
              if (content && content.indexOf("skali-report.s3.us-east-2.amazonaws.com/public/chatPhotos") !== -1) {
                return new Message({
                  id: item.author === username_ ? 0 : item.author,
                  message: <img src={item.content} style={{objectFit:'contain',cursor: 'pointer'}} onClick={() => showImage(item.content)} height={100} width={100} />,
                  senderName: item.author,
                });
              } else {
                return new Message({
                  id: item.author === username_ ? 0 : item.author,
                  message: item.content,
                  senderName: item.author,
                });
              }
            }),
          ];
        });
      }
      setIsLoadingMessages(false);
    };

    getMessages();
    return () => subscribe?.unsubscribe();
  }, [roomId, onNewMessage]);

  const notifyUsers = useCallback(async (sentBy, messageContent) => {
    const notificationHelper = new VideoCallNotificationHelper();
    const medicalEmergencyHelper = new MedicalEmergencyHelper();
    let users = [];
    let cognitoUserId = null;
    const chatInfo = {
      "navigate":"chat",
      "flightId": rootStore.emsStore.getSelectedEmergency.flightId,
      "emergencyId": rootStore.emsStore.getSelectedEmergency.id
    } 

    if (user["custom:type"] === "crew") {
      cognitoUserId = await medicalEmergencyHelper.findEms(rootStore.emsStore.getSelectedEmergency.id);
    } else if (chatType === ChatType.CAPTAIN) {
      cognitoUserId = await medicalEmergencyHelper.findCaptain(rootStore.emsStore.getSelectedEmergency.flightId);
    } else {
      cognitoUserId = await medicalEmergencyHelper.findCrew(rootStore.emsStore.getSelectedEmergency.id);
    }

    if (cognitoUserId) {
      users.push(cognitoUserId);
    }
    if (users.length > 0) {
      notificationHelper.sendVideoCallNotification(sentBy, messageContent, users, chatInfo);
    }
  }, [chatType, rootStore.emsStore.getSelectedEmergency, user]);

  const showImage = (src) => {
    rootStore.emsStore.handleChatImageState({showImage: true, imageUrl: src})
}

  const uploadFile = async (file, roomId) => {
    // const imageExtention = file.name.split(".").pop();
    // const now = Date.now();
    const filePath = `chatPhotos/${roomId}/${file.name}`;
    const currentUrl = window.location.href;
    let region = 'us-east-2'; // Default region
    let bucket = 'skali-report';
  
    // Check if the URL contains "localhost" or "sbx" to decide region
    if (currentUrl.includes('localhost') || currentUrl.includes('sbx')) {
      region = 'us-west-1';  // Set region to us-west-1 for localhost or sbx
      bucket = 'sbx-skali-report'; 
    }


    try {
      // Upload the file to S3
      await Storage.put(filePath, file, {
        bucket: bucket,
        region: region,
        contentType: file.type,
        progressCallback: (progress) => {
          console.log('Upload progress:', progress);
        },
      });
      console.log('File uploaded successfully');

      // Retrieve the public URL of the uploaded file
      const fileUrl = await Storage.get(filePath, {
        bucket: bucket,
        region: region,
        level: 'public', // Adjust access level if needed
        expires: 604799
      });
      const messageContent = fileUrl.split('?')[0];
      console.log('File URL:', fileUrl);
      return messageContent;
    } catch (error) {
      console.error('Error uploading file:', error);
      setFile(null);
      setUploadErr(error);
      throw error;
    }
  };

  
  const onSend = useCallback(async () => {
    Mixpanel.track(`web_send_message_to_${chatType}`, { name: user.username });

    const listQuery = `
      query MyQuery($userId: String!) {
        listTblChatNotifications(filter: { userId: { eq: $userId } }) {
          items {
            userId
            userName
            roomId
          }
        }
      }`;

    const medicalEmergencyHelper = new MedicalEmergencyHelper();
    const cognitoUserId = chatType === ChatType.CAPTAIN
      ? await medicalEmergencyHelper.findCaptain(rootStore.emsStore.getSelectedEmergency.flightId)
      : await medicalEmergencyHelper.findCrew(rootStore.emsStore.getSelectedEmergency.id);

    const userId = cognitoUserId;
    try {
      const res = await API.graphql(graphqlOperation(listQuery, { userId }));
      const item = res?.data?.listTblChatNotifications?.items;
      const sentBy = user.username;

      if (item?.length > 0 && item[0].roomId === roomId) {
        // Handle notifications if needed
      } else {
        if (user["custom:type"] === "crew") {
          notifyUsers(sentBy, "Message from crew");
        } else if (user["custom:type"] === "ems") {
          if (file != null && textMessageInputValue == "") {
            notifyUsers(sentBy, "send image");
          } else {
            notifyUsers(sentBy, "Message from clinician");
          }
        } else {
          notifyUsers(sentBy, textMessageInputValue);
        }
      }

      let fileUrl = null;
      if (file) {
        fileUrl = await uploadFile(file, roomId);
        graph.create(fileUrl, roomId, sentBy);
      }
      if (textMessageInputValue.toString().trim().length > 0) {
        graph.create(textMessageInputValue, roomId, sentBy);
      }
      // Send message with optional file URL
      /*
      let token;
      try {
        let response = await MedicalEmergencyService.getFcmToken();
        token = response.split("Access Token: ")[1];
        console.log("FCM token response", token);
      } catch (error) {
        console.log("Error fetching FCM token", error);
      }
      if ( token ) {
        let crewRecord;
        try {
          const medicalEmergencyHelper = new MedicalEmergencyHelper();
          let cognitoUserIdCrew = await medicalEmergencyHelper.findCrewName(medicalEmergencyId);
          console.log("cognitoUserIdCrew",cognitoUserIdCrew);
          if (cognitoUserIdCrew) {
            await usersService.listUsersByUsername(cognitoUserIdCrew)
            .then((res) => {
              crewRecord = res;
            })
            .catch((error) => {
              console.log("Error fetching crew record", error);
            })
          }
        } catch (error) {
          console.log("Error fetching crew name", error);
        }
          console.log("crew user records", crewRecord);
        if (crewRecord && crewRecord[0]["custom:fcmtoken"]) {
          console.log('crewRecord[0]["custom:fcmtoken"]', crewRecord[0]["custom:fcmtoken"])
          let headersList = {
            "Content-Type": "application/json",
    
            Authorization:
              `Bearer ${token}`,
          };
    
          let bodyContent = JSON.stringify({
            validate_only: false,
    
            message: {
              token: crewRecord[0]["custom:fcmtoken"],
    
              data: {
                type: 'TextMessage',
                flight_id: rootStore.emsStore.getSelectedEmergency?.flightId,
                emergency_id: (rootStore.emsStore.getSelectedEmergency?.id).toString(),
                content_available: "true",
              },
            },
          });
          try {
    
            
            let mesagesendurl;
            if (APIs.BASE_URL.indexOf("sbx") >= 0) {
              mesagesendurl = "https://fcm.googleapis.com/v1/projects/skalisbx/messages:send";
            } else if (APIs.BASE_URL.indexOf("poc") >= 0) {
              mesagesendurl = "https://fcm.googleapis.com/v1/projects/skalisbx/messages:send";
            } else {
              mesagesendurl = "https://fcm.googleapis.com/v1/projects/skali-inc/messages:send";
            }
    
            let response = await fetch(
              mesagesendurl,
              {
                method: "POST",
    
                body: bodyContent,
    
                headers: headersList,
              }
            );
    
            let data = await response.text();
    
            console.log(data);
          } catch (error) {
            console.error("Call Api error", error);
          }
        }
      }
      */
      
      
      // Clear input fields
      setTextMessageInputValue("");
      setFile(null);

      
    } catch (error) {
      console.error(error);
    }
  }, [roomId, notifyUsers, textMessageInputValue, user, file, chatType]);


  const onKeyHandler = (e) => {
    if (textMessageInputValue.trim().length !== 0 && e.key === "Enter") {
      onSend();
    }
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  return (
    <Box flex justify="between" fill>
      <Box className="chatfeed" style={{ flexGrow: 1, marginTop: 8 }} overflow="overflow">
        {isLoadingMessages ? (
          <Box 
            align="center" 
            justify="center" 
            height="100%"
            pad="medium"
          >
            <div className="chat-loader" /> {/* Add your preferred loader */}
            <Text margin={{ top: 'small' }}>Loading messages...</Text>
          </Box>
        ) : (
          <ChatFeed
            messages={messages}
            isTyping={false}
            hasInputField={false}
            showSenderName
            bubblesCentered={false}
          />
        )}
      </Box>
      <Box className="input-box-main">
        <input
          type="file"
          name="file[]"
          ref={fileInputRef}
          style={{ display: 'none' }}
          accept="image/*"
          onChange={(e) => {
            const selectedFile = e.target.files[0];
            if (selectedFile) {
              if (!selectedFile.type.startsWith('image/')) {
                rootStore.notificationToastStore.showNotification(
                  "Please select an image file.",
                  true,
                  3000
                );
                return;
              }
              setFile(selectedFile);
              fileInputRef.current.value = null;
              console.log("Selected file:", selectedFile);
            }
          }}
        />
        <input
          placeholder="Type a message..."
          onChange={(item) => setTextMessageInputValue(item.target.value)}
          className="message-input"
          value={textMessageInputValue}
          onKeyDown={onKeyHandler}
          disabled={medicalStatus === "RESOLVED"}
        />
        <Text className="selected-file-name">{file?.name}</Text>
        <Text className="uploadFileError">{uploadErr}</Text>
        <button
        style={{border: "none",cursor:"pointer"}}
        className="imageUpload"
        onClick={handleImageClick}
        disabled={medicalStatus === "RESOLVED"}
        >
          <img src={image} alt="Upload
          " />
        </button>
      
        <button
          style={{border: "none"}}
          className="sendButton"
          onClick={onSend}
          disabled={(textMessageInputValue.toString().trim().length !== 0) || (file != null)  ? false : true}
        >
          <img src={rightArrow} alt="Send" style={{ width: 24, height: 24 }} />
        </button>
      </Box>
    </Box>
  );
});

export default ChatView;